import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalButtons,
  ModalContent,
  ProgressBar,
} from 'mw-style-react';
import { MANAGE_ACCESS_RULES } from 'constants';
import useIntl from 'useIntl';
import AccessRules from '@control-front-end/common/components/AccessRules';
import { getActiveAccountOwnerId } from '../../../../selectors';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import m from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import l from './ActorsAccessRules.scss'; // NOSONAR

function ActorsAccessRules(props) {
  const {
    data: { rules, objId, objType, ownerId },
    callback,
    visibility,
    onClose,
    isSubmit,
  } = props;
  const t = useIntl();
  const dispatch = useDispatch();
  const accountOwnerId = useSelector(getActiveAccountOwnerId);
  const [access, setAccess] = useState(rules);

  /**
   * Сохранение всех изменений в доступах
   */
  const handleSubmit = () => {
    const body = access
      .filter(({ action }) => !!action)
      .map(({ action, userId, privs }) => {
        const noPrivs = Object.keys(privs).every((level) => !privs[level]);
        return {
          action: noPrivs ? 'delete' : action,
          data: { userId, privs },
        };
      });
    if (objId) {
      dispatch({
        type: MANAGE_ACCESS_RULES.REQUEST,
        payload: { body, objId, objType },
        callback,
      });
    } else {
      callback(access);
    }
    onClose();
  };

  return (
    <Modal
      styleName="m.modal"
      size={objType === 'actor' ? 'xlarge' : 'large'}
      onClose={onClose}
      label={t(mes.manageAccess)}
      visibility={visibility}
    >
      <ModalContent styleName="m.modal__content l.content">
        <AccessRules
          rules={access}
          ownerId={ownerId}
          accountOwnerId={accountOwnerId}
          onChange={setAccess}
          allPrivs={objType === 'actor'}
        />
      </ModalContent>
      <ModalButtons styleName="m.modal__buttons">
        <Button
          label={t(mes.saveRulesChanges)}
          size="large"
          onClick={handleSubmit}
        />
        <ProgressBar
          styleName="m.modal__loader"
          type="circle"
          size="small"
          visibility={isSubmit ? 'visible' : 'hidden'}
        />
      </ModalButtons>
    </Modal>
  );
}

ActorsAccessRules.defaultProps = {
  data: { rules: [] },
};

ActorsAccessRules.propTypes = {
  data: PropTypes.object,
  visibility: PropTypes.bool,
  onClose: PropTypes.func,
  isSubmit: PropTypes.bool,
  callback: PropTypes.func,
};

export default ActorsAccessRules;
